import { render, staticRenderFns } from "./default-full.vue?vue&type=template&id=33f314c4"
import script from "./default-full.vue?vue&type=script&lang=js"
export * from "./default-full.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports